/**
 * 轮播图功能相关
 */
module.exports = {
  carousel: {
    slidesPerView: 'auto', // 展示数量
    slidesPerColumn: 1, // 每列展示数量
    slidesPerColumnFill: 'column', // 多行布局中以什么形式填充
    autoplay: true, // 自动播放
    loop: false, // 循环
    loopDelay: 3000,
    direction: 'horizontal',
    speed: 300, //切换速度
    mousewheel: false, //是否开启鼠标滚轮控制Swiper切换
    slideToClickedSlide: false, // 设置为true则点击slide会过渡到这个slide
    viewStyle: 'slide',
    slides: { normal: [] },
    bulletClickable: false,
    scrollbarHide: false,
    scrollbarDraggable: false,
    scrollbarSnap: true,
    scrollbarDragSize: 'auto',
    slideShadows: true, // 是否开启slide阴影
    shadow: true, // 是否开启投影
    rotate: 50, // slide做3d旋转时Y轴的旋转角度
    depth: 100, // 位置深度
    stretch: 0, // 每个slide之间的拉伸值，越大slide靠得越紧
    threshold: 0, // 默认滑动30px,才进行滚动,防止点击的时候误触发滚动
    longSwipesRatio: 0.5, // 默认长滑动屏幕的50%，才会触发屏幕滚动
    autoHeight: false, //自动高度
  },
};
